import { render, staticRenderFns } from "./FpNavDotsSection.vue?vue&type=template&id=0b8ba2b1&"
import script from "./FpNavDotsSection.vue?vue&type=script&lang=js&"
export * from "./FpNavDotsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports